


















import Vue from 'vue';
import {Component, Prop} from 'vue-property-decorator';
import NumberPads from '@/components/Money/numberPads.vue';

@Component({
    components: {NumberPads}
})
export default class extends Vue {


    @Prop({default: ''}) title: string | undefined;

    handleClick(){
        this.$emit('toggleOff',[1,2])
    }

}
